import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { GetOne } from './../providers/dataProvider';


export const useMultiplier = (resource) =>{
   // const {resource} = params;
   const navigate = useNavigate();
    const [multiplierList, setMultiplierList] = useState(null)
    const [userMultiplier, setUserMultiplier] = useState(null)

    const userProfile = JSON.parse(localStorage.getItem("userProfile"));
    useEffect(() => {
            if(userProfile?.roleId)GetOne("rolemultiplier", { id: userProfile?.roleId }, setMultiplierList)
    }, [userProfile?.roleId])


    useEffect(() => {
        if(multiplierList?.data)setUserMultiplier(multiplierList?.data)
    }, [multiplierList])

    return{userMultiplier}
}